import React, { Suspense } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

import { PasswordRecover } from "../Containers/PasswordRecover";
export const PasswordRecoverPage = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={t("comp.loading")}>
      <Helmet>
        <title>{t("comp.recoverPage")} | {t("comp.header")}</title>
      </Helmet>
      <PasswordRecover />
    </Suspense>
  );
};
